import { c as _c } from "react/compiler-runtime";
import { PrV2ViewedCheckboxIndicator } from '../pr-v2-viewed-checkbox-indicator';
import { Button } from '@/components/ui/button';
import { KeyboardKey } from '@/components/ui/keyboard-key';
import { BetterTooltip } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
type PrV2FileHeaderViewedToggleButtonProps = {
  filename: string;
  isViewed: boolean;
  onToggleViewed: () => void;
};
export function PrV2FileHeaderViewedToggleButton(t0) {
  const $ = _c(19);
  const {
    filename,
    isViewed,
    onToggleViewed
  } = t0;
  const t1 = isViewed ? "Mark unviewed" : "Mark viewed";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <KeyboardKey>Space</KeyboardKey>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <span className="flex items-center gap-2">{t1}{t2}</span>;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = isViewed ? `Mark ${filename} as unviewed with Space` : `Mark ${filename} as viewed with Space`;
  let t5;
  if ($[3] !== onToggleViewed) {
    t5 = event => {
      event.stopPropagation();
      onToggleViewed();
    };
    $[3] = onToggleViewed;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = isViewed && "bg-zinc-800 text-zinc-200 hover:bg-zinc-700 hover:text-zinc-100";
  let t7;
  if ($[5] !== t6) {
    t7 = cn("h-6 shrink-0 gap-1.5 rounded-sm px-2 text-[13px] text-zinc-500 hover:text-zinc-300 [&_svg]:size-3", t6);
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== isViewed) {
    t8 = <PrV2ViewedCheckboxIndicator isViewed={isViewed} />;
    $[7] = isViewed;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span>Viewed</span>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== isViewed || $[11] !== t4 || $[12] !== t5 || $[13] !== t7 || $[14] !== t8) {
    t10 = <Button type="button" variant="ghost" size="sm" aria-label={t4} aria-pressed={isViewed} data-pr-v2-file-header-control="true" onClick={t5} className={t7}>{t8}{t9}</Button>;
    $[10] = isViewed;
    $[11] = t4;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t3) {
    t11 = <BetterTooltip content={t3} side="top">{t10}</BetterTooltip>;
    $[16] = t10;
    $[17] = t3;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
}